import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import InfoSiteHelpers from 'infosite/helpers';
import { slide as Menu} from 'react-burger-menu';
import MenuStore from './store';
import MenuActions from './actions';
import NavMenu from 'infosite/navigation/nav-menu';
import InfositeHelpers from 'infosite/helpers';

export default class SideMenu extends Reflux.Component{

    constructor(props){
        super(props);
        this.state = {};
        this.store = MenuStore;
        this.settings = props.navigation.mobile;
    }

    componentDidMount() {
        //let $this = $(ReactDOM.findDOMNode(this));
    }
    componentDidUpdate(){
        if(this.state.isOpen){
           InfositeHelpers.lockScroll('mobile-menu');
        }else{
           InfositeHelpers.unlockScroll('mobile-menu');
        }
    }
    toggle(state){
    	if(state.isOpen != this.state.isOpen){
    		MenuActions.toggle();
    	}
    }
    doItemClick(navItem) {
      const itemModule = navItem.props.item.module;
      if(navItem.props.item.submenu!=null && navItem.props.item.submenu.length>0) {
        if(!navItem.state.isExpanded) {
            this.expandedSubmenu = navItem;
        }
        navItem.setState({
            isExpanded: !navItem.state.isExpanded
        });
      } else if(this.state.isOpen && (itemModule=="RouterLink" || itemModule=="IsiLink" || (itemModule==="default"))) {
        MenuActions.toggle();
      }
    }
    render() {
      const navItems = this.props.navigation.links;
      let _class = cx({
        'menu-container': true,
        'position-right': this.settings.position=='right'
      })
      const NavMenuProps = {
        items: navItems,
        settings: this.settings,
        route: this.props.route,
        isSubmenu: false,
        onItemClick: this.doItemClick.bind(this)
      }
        const MenuProps = {
        	isOpen: this.state.isOpen,
        	customBurgorIcon: false,
        	right: this.settings.position=="right",
        	onStateChange: this.toggle.bind(this)
        }
        return (
        	<div id="side-menu">
	            <Menu {...MenuProps} >
	                <NavMenu {...NavMenuProps}></NavMenu>
	            </Menu>
            </div>
        );
    }

}
SideMenu.propTypes={
    "navigation": React.PropTypes.object.isRequired,
    "route": React.PropTypes.object.isRequired
}
SideMenu.defaultProps={
}



// WEBPACK FOOTER //
// ./src/app/mobile-menu/side-menu.jsx